import * as React from 'react';
export const embeddedCheckoutSvg = React.forwardRef(
  function embeddedCheckoutSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 14.25v-1.563a.75.75 0 0 1 1.5 0v1.563c0 .138.112.25.25.25h1.563a.75.75 0 0 1 0 1.5H1.75A1.75 1.75 0 0 1 0 14.25Zm9.563.25a.75.75 0 0 1 0 1.5H6.437a.75.75 0 0 1 0-1.5h3.125Zm4.937-.25v-1.563a.75.75 0 0 1 1.5 0v1.563A1.75 1.75 0 0 1 14.25 16h-1.563a.75.75 0 0 1 0-1.5h1.563a.25.25 0 0 0 .25-.25ZM0 9.562V6.438a.75.75 0 0 1 1.5 0v3.125a.75.75 0 0 1-1.5 0Zm14.5 0V6.438a.75.75 0 0 1 1.5 0v3.125a.75.75 0 0 1-1.5 0ZM0 3.313V1.75C0 .784.784 0 1.75 0h1.563a.75.75 0 0 1 0 1.5H1.75a.25.25 0 0 0-.25.25v1.563a.75.75 0 0 1-1.5 0Zm14.5 0V1.75a.25.25 0 0 0-.25-.25h-1.563a.75.75 0 0 1 0-1.5h1.563C15.216 0 16 .784 16 1.75v1.563a.75.75 0 0 1-1.5 0ZM9.562 0a.75.75 0 0 1 0 1.5H6.438a.75.75 0 0 1 0-1.5h3.125Z',
      }),
    );
  },
);
embeddedCheckoutSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var embeddedCheckout = {
  category: 'icon',
  colorable: true,
  name: 'embeddedCheckout',
  svg: embeddedCheckoutSvg,
};
